import { LegacyModal } from '@joor/design-system'
import styled from 'styled-components'

export const ManualPaymentsFormContainer = styled.div`
  display: flex;
  column-gap: 40px;
  row-gap: 20px;
  flex-direction: column;
  width: calc(80vw - 32px);
  @media (min-width: 992px) {
    flex-direction: row;
    width: 800px;
  }
  > div {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    @media (min-width: 992px) {
      width: unset;
      flex: 1;
    }
    &:first-of-type > div {
      display: flex;
      column-gap: 20px;
      > *:first-child {
        flex: 1;
      }
      > *:last-child {
        width: 35%;
      }
    }
  }
`

export const StyledModal = styled(LegacyModal)`
  overflow: visible;
  form > div:first-of-type {
    overflow: visible;
  }
`
